/** 지옥 1층 ‘구역’ 클리어 — 현재는 제1구역 `1-1` 만 (내부 5단계 포함). */
export const REGISTRY_HELL1_CLEARED_STAGES = 'progress.hell1.clearedStages';

/** 허브에 노출할 구역 ID (나중에 1-2 구역 등 추가). */
export const HELL1_ZONE_IDS = ['1-1'] as const;
export type Hell1ZoneId = (typeof HELL1_ZONE_IDS)[number];

export function recordHell1StageClear(registry: Phaser.Data.DataManager, zoneId: string): void {
  const raw = registry.get(REGISTRY_HELL1_CLEARED_STAGES);
  const arr = Array.isArray(raw) ? [...raw] : [];
  if (!arr.includes(zoneId)) arr.push(zoneId);
  registry.set(REGISTRY_HELL1_CLEARED_STAGES, arr);
}

export function getHell1ClearedStages(registry: Phaser.Data.DataManager): string[] {
  const raw = registry.get(REGISTRY_HELL1_CLEARED_STAGES);
  return Array.isArray(raw) ? [...raw] : [];
}

export function isHell1StageCleared(registry: Phaser.Data.DataManager, zoneId: string): boolean {
  return getHell1ClearedStages(registry).includes(zoneId);
}
